
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intermediaries",
      function () {
        return require("private-next-pages/intermediaries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intermediaries"])
      });
    }
  